import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as S from "./styles";
import { DecorativeDot } from "../../../lib/styles";
import Loader from "../../../components/ui/Loader";
import { getPosts } from "../../../services/blog";
import ArticleCard from "../../../pages/Blogs/ArticleCard";

export function LatestBlogs() {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState(null);

  useEffect(() => {
    (async () => {
      const data = {
        newest: true,
        limit: 3,
        offset: 0,
      };

      const result = await getPosts(data);

      setBlogs(result.posts || []);
    })();
  }, []);

  const handleOpenBlog = (blog) => {
    navigate(`/blog/${blog.link}`);
  };

  const handleOpenBlogsByTag = (blog) => {
    navigate("/blogs", {
      state: { tag: blog.tag },
    });
  };

  const handleViewAll = () => {
    navigate("/blogs");
  };

  return (
    <S.StyledSection>
      {!blogs && (
        <Loader
          styles={{
            position: "absolute",
            left: "48%",
            top: "48%",
            width: "fit-content",
            height: "fit-content",
          }}
        />
      )}

      <S.Heading>
        Read our <S.HeadingHighlight>latest news</S.HeadingHighlight>
        <DecorativeDot src="/images/icons/dot-grey.svg" alt="Decorative dot" />
      </S.Heading>
      {!!blogs?.length && (
        <S.ArticleGrid>
          {blogs.map((blog, index) => (
            <ArticleCard
              key={index}
              data={blog}
              onClick={() => handleOpenBlog(blog)}
              openBlogsByTag={() => handleOpenBlogsByTag(blog)}
            />
          ))}
        </S.ArticleGrid>
      )}
      <S.ViewAllBtn onClick={handleViewAll}>
        View all blog posts
        <img src="/images/icons/arrow-top-right-white.svg" alt="Arrow right" />
      </S.ViewAllBtn>
    </S.StyledSection>
  );
}
